// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ZmMo","requiredAsterisk":"Info_requiredAsterisk__3ga36"};